import { GridHeaders } from '@project-types/GridHeaders';
import { getHeadersObjectBase } from '@pages/reporting-pages/utils';
import { ShowReasonColumn } from '@pages/reporting-pages/ShowReasonColumn';
import { ReducedGridData } from '@pages/reporting-pages/reduced-orders/types/ReducedGridData';



export const headersObject: GridHeaders<ReducedGridData> = [
	{ label: '', key: '', width: '2.5rem' },
	{ label: 'Zákazník', key: 'orderCustomerSapId', width: '1fr' },
	{ label: 'Název', key: 'name', width: '2fr' },
	{ label: 'Město', key: 'city', width: '2fr' },
	{ label: 'Ulice', key: 'street', width: '2fr' },
	{ label: 'Obchodník', key: 'salesMan', width: '2fr' },
	{ label: 'TLS operátor', key: 'tlsOperator', width: '2fr' },
	{ label: 'Komentář', key: 'comment', width: '2fr' },
	{ label: 'Důvod z plánování', key: 'orderPlanningReasonName', width: '2fr' },
	{ label: 'Důvod z exekuce', key: 'orderExecutionReasonName', width: '2fr' },
	{ label: 'ID objednávky', key: 'orderClientId', width: '1fr' },
	{ label: 'Nový datum doručení objednávky', key: 'orderRequiredDeliveryDate', width: '1fr' },
	{ label: 'Depo', key: 'orderExecutionPlace', width: '1fr' },
	{ label: 'Distribuce', key: 'distributionType', width: '1fr' },
	{ label: 'Distribuční kód', key: 'shipmentDistributionCode', width: '1fr' },
	{ label: 'Pokrátil', key: 'reducedBy', width: '1fr' },
	{ label: 'Původní počet [ks]', key: 'orderOrderedCount', width: '1fr' },
	{ label: 'Poslaný počet [ks]', key: 'orderSentCount', width: '1fr' },
	{ label: 'Dodaný počet [ks]', key: 'orderDeliveredCount', width: '1fr' },
	{ label: 'Původní objem [hl]', key: 'orderOrderedVolume', width: '1fr' },
	{ label: 'Poslaný objem [hl]', key: 'orderSentVolume', width: '1fr' },
	{ label: 'Dodaný objem [hl]', key: 'orderDeliveredVolume', width: '1fr' },
	{ label: 'Objednaný - poslaný počet [ks]', key: 'orderedMinusSentCount', width: '1fr' },
	{ label: 'Poslaný - doručený počet [ks]', key: 'sentMinusDeliveredCount', width: '1fr' },
	{ label: 'Objednaný - poslaný objem [hl]', key: 'orderedMinusSentVolume', width: '1fr' },
	{ label: 'Poslaný - doručený objem [hl]', key: 'sentMinusDeliveredVolume', width: '1fr' },
]



export const getHeadersObject = (showReasonColumn: ShowReasonColumn) => getHeadersObjectBase(headersObject, showReasonColumn);